const CONFIG = {
  URL: "https://utcquiz-api.eventqiu.com/api",
};

export default CONFIG;
